import React, { useState, useEffect, useRef, useMemo } from "react";
import LayoutIcon from "src/components/icons/miscs/layout";
import AddIcon from "src/components/icons/common/add-icon";
import { useAppSelector, useAppDispatch } from "src/hooks/redux";
import TrashIconTwo from "src/assets/images/TrashTwo.svg";
import BookIcon from "src/assets/images/book.svg";
import SwitchIcon from "src/assets/images/switch.svg";
import uploadicon from "src/assets/images/upload.svg";
import { extractFileData, updatePitchdeckData } from "src/stores/vs-product";
import SingleFileCard from "./FileInternalSource";
import DotLoader from "src/components/reusable/dot-loader";

function normalizeDataSource(input: any): {
  Internal?: { [key: string]: string[] };
  External?: { [key: string]: string[] };
  Flat?: { [key: string]: string[] };
} {
  if (!input || typeof input !== "object") return {};

  const result: any = {};

 

  // Handle Internal
  if ("Internal" in input && Array.isArray(input.Internal)) {
    result.Internal = { Internal: input.Internal };
  }

  // Handle External sources
  if ("External sources" in input) {
    try {
      let parsed: any = input["External sources"];

      // If it's a string, try parsing JSON
      if (typeof parsed === "string") {
        try {
          parsed = JSON.parse(parsed);
        } catch (err) {
          console.error("Failed to parse External sources string:", err);
          parsed = null;
        }
      }

      if (typeof parsed === "object" && parsed !== null) {
        result.External = {};
        for (const key in parsed) {
          if (Array.isArray(parsed[key])) {
            result.External[key] = parsed[key];
          }
        }
      }
    } catch (err) {
      console.error("Failed to handle external data source:", err);
    }
  }

  // Fallback: Flat format if no Internal/External present
  if (!("Internal" in input) && !("External sources" in input)) {
    result.Flat = {};
    for (const key in input) {
      if (Array.isArray(input[key])) {
        result.Flat[key] = input[key];
      }
    }
  }

  return result;
}


interface Props {
  dataSource: any;
  disabled?: boolean;
}
const SourcesData: React.FC<Props> = (props) => {
  const { dataSource, disabled } = props;
  const dispatch = useAppDispatch();



  const normalizedData: any = useMemo(()=>normalizeDataSource(dataSource),[dataSource])
  const dataTypes = Object.keys(normalizedData); // ['Internal', 'External'] or ['Flat']

  

  const [activeTypeTab, setActiveTypeTab] = useState<string>(dataTypes[0] || "");
  const currentGroup = normalizedData[activeTypeTab] || {};
  const dataSourceKeys = Object.keys(currentGroup).filter((key) => currentGroup[key]?.length);
  const [activeSubTab, setActiveSubTab] = useState<string>(dataSourceKeys[0] || "");
  const [items, setItems] = useState<{ [key: string]: string[] }>(currentGroup);

  const [additionalDataSources, setadditionalDataSources] = useState<{ [key: string]: string[] }>(
    {},
  );
  const [newItem, setNewItem] = useState("");
  const [isInputVisible, setIsInputVisible] = useState(false);
  const [open, setOpen] = useState(true);

  useEffect(() => {
    // setItems(DataSources);
    dispatch(updatePitchdeckData({ additionalDataSources: { ...additionalDataSources } }));
  }, [additionalDataSources]);

  useEffect(() => {
    const group = normalizedData[activeTypeTab] || {};
    setItems(group);
    const newKeys = Object.keys(group);
    setActiveSubTab(newKeys[0] || "");
  }, [activeTypeTab]);

  const itemsToDisplay = items[activeSubTab] || [];
  const additionalItems = additionalDataSources?.[activeSubTab] || [];
 const handleDelete = (itemToDelete: string) => {
  setItems((prevItems) => {
    const updated = {
      ...prevItems,
      [activeSubTab]: (prevItems[activeSubTab] || []).filter((item: any) => {
        if (typeof item === "string") {
          return item !== itemToDelete;
        } else if (typeof item === "object" && item !== null) {
          return item.url !== itemToDelete;
        }
        return true;
      }),
    };
    return updated;
  });

  setadditionalDataSources((prevItems) => {
    const updated = {
      ...prevItems,
      [activeSubTab]: (prevItems?.[activeSubTab] || []).filter((item: any) => {
        if (typeof item === "string") {
          return item !== itemToDelete;
        } else if (typeof item === "object" && item !== null) {
          return item.url !== itemToDelete;
        }
        return true;
      }),
    };
    return updated;
  });

  dispatch(updatePitchdeckData({ additionalDataSources }));
};

  const handleAdd = () => {
    if (newItem.trim()) {
      setadditionalDataSources((prevItems) => ({
        ...prevItems,
        [activeSubTab]: prevItems?.[activeSubTab]
          ? [...(prevItems?.[activeSubTab] || {}), newItem.trim()]
          : [newItem.trim()],
      }));
      setNewItem("");
      setIsInputVisible(false);
    }
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      handleAdd();
    }
  };

  const [isExpanded, setIsExpanded] = useState(false);
  const toggleExpand = () => setIsExpanded(!isExpanded);

  const [attachedFiles, setAttachedFiles] = useState<File[]>([]);
  const [error, setError] = useState<string | null>(null);

  const fileInputRef = useRef<any>(null);

  const handleAttachClick = () => {
    fileInputRef.current?.click();
  };

  const [fileUplaoding, setFileUplaoding] = useState(false);

  const handleFileChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    setFileUplaoding(true)
    const files = event.target.files;
    if (files && files.length > 0) {
      const validTypes = [
        "application/pdf",
        "application/vnd.ms-powerpoint",
        "application/vnd.openxmlformats-officedocument.presentationml.presentation",
        "application/msword",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        // Excel formats
        "application/vnd.ms-excel",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        // CSV
        "text/csv",
        // JSON
        "application/json"
      ];

      const selectedFiles: File[] = Array.from(files).filter((file) =>
        validTypes.includes(file.type),
      );

      if (selectedFiles.length !== files.length) {
        setError("Some files have invalid types. Only PDF, PPT, Excel or Word documents are allowed.");
      } else {
        setError(null);
      }

      setAttachedFiles((prevFiles) => [...prevFiles, ...selectedFiles]);
      const pptResp = await dispatch(extractFileData(selectedFiles)).unwrap();
      const fileResponse = pptResp?.fileData;
      if (pptResp) {
        setFileUplaoding(false)
      }
      if (fileResponse && typeof fileResponse === "object") {
        const newUrls = Object.keys(fileResponse);

        // Update items state (Internal tab only)
        setItems((prev: any) => ({
          ...prev,
          Internal: [...(prev.Internal || []), ...newUrls],
        }));

        // Track in additionalDataSources if needed (to persist or track user additions)
        setadditionalDataSources((prev: any) => ({
          ...prev,
          Internal: [...(prev.Internal || []), ...newUrls],
        }));
      }
     
      event.target.value = "";
    }
  };

  return (
    <div
      className={`min-w-[460px] rounded-lg w-full mb-[70px] overflow-y-auto ${open
        ? "flex-[0_0_100%] sm:flex-[0_0_75%] lg:flex-[0_0_460px] max-w-full lg:max-w-[460px]"
        : "flex-[0_0_100%] sm:flex-[0_0_215px] max-w-full sm:max-w-[215px]"
        }`}
    >
      <div
        className={` ${open ? "w-full h-full" : "w-full h-auto"
          } bg-opacity-50 rounded-lg`}
      >
        <div className="flex">
          <div className="cursor-pointer py-1">
            <img src={BookIcon} alt="book" className="w-full  object-contain min-w-[20px]" />
          </div>
          <div className="ml-2 flex-auto">
            <div className="flex justify-between">
              <h2 className="text-lg font-semibold">Data Sources</h2>
              <div
                onClick={() => setOpen(!open)}
                className="cursor-pointer rounded border border-[#DFE3E8] p-1"
              >
                <img
                  src={SwitchIcon}
                  alt="book"
                  className="w-full h-full object-contain min-w-[20px]"
                />
              </div>
            </div>
            {open && (
              <>
                <div className="flex flex-col justify-center mb-2">
                  <div className="text-xs sm:text-sm inline-flex mt-4 mb-2 mx-auto border-gray-300 border rounded-lg justify-center overflow-hidden">
                    {dataTypes.map((type) =>
                      type === "Flat" ? null : (
                        <button
                          key={type}
                          className={`px-2 py-1 text-xs inline-flex sm:text-sm ${activeTypeTab === type ? "bg-primary-900 text-white " : ""
                            }`}
                          onClick={() => setActiveTypeTab(type)}
                        >
                          {type}
                        </button>
                      ),
                    )}
                  </div>
                  {activeTypeTab === "Internal" ? (
                    <div className="text-center font-semibold text-xs mb-1">
                      (Uploaded or auto-extracted)
                    </div>
                  ) : (
                    <div className="text-center font-semibold text-xs mb-1">
                      AI-Suggested Sources (based on focus area)
                    </div>
                  )}

                  {activeTypeTab === "Internal" ? null : (
                    <>


                      <div className="text-xs sm:text-sm flex gap-1 flex-wrap">
                        {dataSourceKeys.map((tab) => (
                          <button
                            key={tab}
                            className={`py-1 px-2 text-xs sm:text-sm rounded-lg ${activeSubTab === tab ? "bg-[#EFE6FF] text-[#442873]" : ""
                              }`}
                            onClick={() => setActiveSubTab(tab)}
                          >
                            {tab.charAt(0).toUpperCase() + tab.slice(1)}
                          </button>
                        ))}
                      </div>
                    </>
                  )}
                </div>
                {/* <div className="text-xs sm:text-sm">
                  {dataSourceKeys.map((tab) => (
                    <button
                      key={tab}
                      className={`p-1 text-xs sm:text-sm rounded-lg ${activeTab === tab ? "bg-appGray-200" : ""
                        }`}
                      onClick={() => setActiveTab(tab)}
                    >
                      {tab.charAt(0).toUpperCase() + tab.slice(1)}
                    </button>
                  ))}
                </div> */}
              </>
            )}
          </div>
        </div>
        {open && (
          <div className="flex flex-col gap-y-2 h-[90%] lg:max-h-[70vh] lg:h-auto pb-2">
            <div className="h-[50vh] md:h-[70vh] pn_scroller overflow-y-auto">
              {/* {itemsToDisplay?.length === 0 ? (
                <div className="flex items-center py-1  rounded-lg mb-2 p-1 gap-1 justify-center">
                  <p>No Internal Data Source Found</p>
                </div>
              ) : (
                ""
              )} */}
              {/* If the items are array of objects, show table */}
              {Array.isArray(itemsToDisplay) &&
                typeof itemsToDisplay[0] === "object" &&
                itemsToDisplay[0] !== null ? (
                <div className="overflow-x-auto mb-2">
                  <table className="min-w-full border-gray-100 text-xs sm:text-sm">
                    <thead className="bg-gray-100 text-left">
                      <tr>
                        <th className="p-1">Source</th>
                        <th className="p-1">CI</th>
                        <th className="p-1">Accuracy</th>
                      </tr>
                    </thead>
                    <tbody>
                      {itemsToDisplay.map((item: any, index: number) => (
                        <tr key={item.url || index} className="border-t">
                          <td className="p-1 border">
                            <div className="flex items-center gap-1">
                              {item.favicon ? (
                                <a
                                  href={item.url}
                                  className="text-[#373D3F]"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  <img src={item.favicon} alt="favicon" className="w-4 h-4 flex-[0_0_32px]" />
                                </a>
                              ) : (
                                "N/A"
                              )}
                              {item.title ? (
                                <a
                                  href={item.url}
                                  className="text-[#373D3F] whitespace-nowrap max-w-[200px] text-ellipsis overflow-hidden"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  {item.title}
                                </a>
                              ) : (
                                "N/A"
                              )}
                            </div>
                          </td>
                          {/* <td className="p-1 border">{item.title ? <a
                            href={item.url}
                            className="text-blue-700 underline break-all"
                            target="_blank"
                            rel="noopener noreferrer"
                          >{item.title}</a> : "N/A"}</td> */}
                          <td className="p-1 border">{`${(item.ci_score || 0) * 100}%`}</td>
                          <td className="p-1 border capitalize">{item.accuracy ?? "N/A"}</td>

                          <td className="p-2 border">
                            {!disabled && (
                              <button
                                className="text-red-500"
                                onClick={() => handleDelete(item.url)}
                              >
                                <img src={TrashIconTwo} alt="Delete" className="w-2 h-2" />
                              </button>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                // Fallback to default list if array of strings
                <>
                  {itemsToDisplay.length === 0 ? (
                    <div className="flex items-center py-1 rounded-lg mb-2 p-1 gap-1 justify-center">
                      <p>No Internal Data Source Found</p>
                    </div>
                  ) : null}
                  {itemsToDisplay.map((item: string) =>
                    activeTypeTab === "Internal" ? (
                      <SingleFileCard
                        key={item}
                        fileUrl={item}
                        onPreview={(url) => window.open(url, "_blank")}
                        onDelete={(url) => handleDelete(url)}
                      />
                    ) : (
                      <div
                        key={item}
                        className="flex items-center py-1 border border-gray-300 rounded-lg mb-2 p-1 gap-1 justify-between"
                      >
                        <a
                          href={item}
                          className="flex-auto break-all leading-tight text-xs sm:text-sm text-blue-700"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {item}
                        </a>
                        {!disabled && (
                          <button
                            className="text-red-500 flex-[0_0_20px]"
                            onClick={() => handleDelete(item)}
                          >
                            <img src={TrashIconTwo} alt="Delete" className="w-4 h-4" />
                          </button>
                        )}
                      </div>
                    ),
                  )}
                </>
              )}



              {additionalItems.map((item) => (
                activeTypeTab === "Internal" ?
                  <SingleFileCard
                    key={item}
                    fileUrl={item}
                    onPreview={(url) => window.open(url, "_blank")}
                    onDelete={(url) => handleDelete(url)}
                    additional={true}
                  /> :
                  <div
                    key={item}
                    className="flex items-center py-1 border border-gray-300 rounded-lg mb-2 p-1 gap-1 justify-between bg-orange-50 "
                  >
                    <a
                      href={item}
                      className="flex-auto break-all leading-tight text-xs sm:text-sm text-blue-700"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {item}
                    </a>
                    {disabled ? null : (
                      <button
                        className="text-red-500 flex-[0_0_20px]"
                        onClick={() => handleDelete(item)}
                      >
                        <img src={TrashIconTwo} alt="Delete" className="w-4 h-4" />
                      </button>
                    )}
                  </div>
              ))}
            </div>
            {fileUplaoding ? <div className="flex items-center justify-center p-5 h-full"><DotLoader /> </div> : null}
            {disabled ? null : activeTypeTab ===
              "Internal" ?
              <div className="flex justify-center"> <button className="flex items-center gap-2 p-2 w-fit h-[36px] text-sm border-[#442873] border rounded-full text-[#442873]" onClick={handleAttachClick}> <img
                src={uploadicon}
                alt="upload"
                className="w-[20px] h-[20px] object-contain"
              />Upload Internal Data Source</button>
                <input
                  type="file"
                  multiple
                  ref={fileInputRef}
                  onChange={handleFileChange}
                  className="file-input hidden"
                />
              </div>
              :

              activeTypeTab === "External" ? (
                <div className="flex justify-center">
                  {isInputVisible && (
                    <input
                      type="text"
                      className="border border-gray-300 p-1 rounded-lg flex-grow w-full text-xs sm:text-sm placeholder:text-appGray-600 focus:outline-none focus:ring-0"
                      placeholder="Add new item"
                      value={newItem}
                      onChange={(e) => setNewItem(e.target.value)}
                      onKeyDown={handleKeyDown}
                    />
                  )}
                  {!isInputVisible &&
                    <button
                      className={`flex items-center gap-2 p-2 w-fit h-[36px] text-sm border-[#442873] border rounded-full text-[#442873] ${isInputVisible ? "hidden" : ""
                        }`}
                      onClick={() => setIsInputVisible(!isInputVisible)}
                    >
                      Suggest Custom Source
                    </button>}
                </div>
              ) : (
                <div className="flex justify-between items-center py-1 border border-gray-300 rounded-lg mb-2 p-1">
                  {isInputVisible && (
                    <input
                      type="text"
                      className="border border-gray-300 p-1 rounded-lg flex-grow w-full text-xs sm:text-sm placeholder:text-appGray-600 focus:outline-none focus:ring-0"
                      placeholder="Add new item"
                      value={newItem}
                      onChange={(e) => setNewItem(e.target.value)}
                      onKeyDown={handleKeyDown}
                    />
                  )}
                  <button
                    className={`flex items-center justify-start text-primary-900 ${isInputVisible ? "hidden" : ""
                      }`}
                    onClick={() => setIsInputVisible(!isInputVisible)}
                  >
                    {!isInputVisible && (
                      <>
                        <AddIcon color="#442873" size={25} />
                        <span className="text-xs sm:text-sm">Add</span>
                      </>
                    )}
                  </button>
                </div>
              )}
          </div>
        )}
      </div>
    </div>
  );
};

export default SourcesData;
